import { useState, useEffect } from "react";
import NocService from "../NOC/NocService";
import styled from "styled-components";
import { Form } from "react-bootstrap";
import "../style/style.css";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const ChangePwd = () => {
    const navigate = useNavigate();
    const [userName, setUserName] = useState('');
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    useEffect(() => {
        const userDetails = sessionStorage.getItem('userDetails');
        if (userDetails) {
            const parsedDetails = JSON.parse(userDetails);
            setUserName(parsedDetails.userName);
        }
    }, []);
    const signOut = () => {
        try {
            sessionStorage.clear();
        } catch (error) {
            console.error("Error clearing sessionStorage:", error);
        }
        // Navigate to login page
        navigate('/my-login');
    };
    const handlePasswordChange = () => {
        if (!oldPassword || !newPassword || !confirmPassword) {
            alert("Please fill all fields.");
            return;
        }
        if (newPassword.length < 8 || confirmPassword.length < 8) {
            alert("Please enter password more than 8 digit")
            return;
        }
        if (newPassword !== confirmPassword) {
            alert("New password and confirm password do not match.");
            return;
        }

        const data = {
            userName,
            oldPassword,
            newPassword
        };

        NocService.ChangePassword(data).then((result) => {
            if (result.status === 500) {
                alert("Failed to change password.");

            } else {
                alert("Password changed successfully.");
                signOut();

            }
        }).catch((error) => {
            console.error("Error changing password:", error);
            alert("Write old passoword correctly")
            alert("An error occurred while changing the password.");
        });
    };

    return (
        <div className="container-fluid">
            <Form id='changePwdForm'>
                <div className="row">
                    <h2 className="text-center ">Change Password</h2>
                </div>
                <div className="row">
                    <div className="mb-3">
                        <input
                            type="hidden"
                            className="form-control"
                            value={userName}
                        />
                    </div>
                    <div className="mb-3  position-relative">
                        <input
                            type={showOldPassword ? "text" : "password"}
                            placeholder="Enter Old Password"
                            className="form-control"
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                        />
                        <button
                            type="button"
                            className="btn btn-outline-secondary position-absolute end-0 top-50 translate-middle-y"
                            onClick={() => setShowOldPassword(!showOldPassword)}
                            style={{ border: 'none', background: 'transparent', margin: '-12px 12px 0 0', boxShadow: 'none' }}
                        >
                            {showOldPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                    </div>
                    <div className="mb-3  position-relative">
                        <input
                            type={showNewPassword ? "text" : "password"}
                            placeholder="Enter New Password"
                            className="form-control"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />

                        <button
                            type="button"
                            className="btn btn-outline-secondary position-absolute end-0 top-50 translate-middle-y"
                            onClick={() => setShowNewPassword(!showNewPassword)}
                            style={{ border: 'none', background: 'transparent', margin: '-12px 12px 0 0', boxShadow: 'none' }}
                        >
                            {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                    </div>
                    <div className="mb-3 position-relative">
                        <input
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Confirm New Password"
                            className="form-control"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                        <button
                            type="button"
                            className="btn btn-outline-secondary position-absolute end-0 top-50 translate-middle-y"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            style={{ border: 'none', background: 'transparent', margin: '-12px 12px 0 0', boxShadow: 'none' }}
                        >
                            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                    </div>
                    <div className="d-flex align-items-baseline justify-content-center">
                        <button type="button" onClick={handlePasswordChange} className="btn mt-0  main-button">Change Password</button>
                    </div>
                </div>
            </Form>
        </div>
    );
}

export default ChangePwd;
